export function deriveScheduleString(scheduleDates: string[], locale: string): string {
  if (!scheduleDates || scheduleDates.length === 0) return "";

  const dayNames = scheduleDates.map((iso) => {
    const date = new Date(iso);
    return date.toLocaleDateString(locale, { weekday: "long" });
  });

  const hourCounts: Record<number, number> = {};
  scheduleDates.forEach((iso) => {
    const h = new Date(iso).getHours();
    hourCounts[h] = (hourCounts[h] ?? 0) + 1;
  });
  const modeHour = parseInt(
    Object.entries(hourCounts).sort((a, b) => b[1] - a[1])[0][0],
    10
  );

  const uniqueDays = Array.from(new Set(dayNames));
  const daysStr = uniqueDays.join(" and ");

  const hour12 = modeHour % 12 === 0 ? 12 : modeHour % 12;
  const amPm = modeHour >= 12 ? "pm" : "am";
  const timeStr = `${hour12}:00${amPm}`;

  return `${daysStr} at ${timeStr}`;
}

export function formatPaymentType(paymentType: string): string {
  if (paymentType === "attendance") return "Attendance";
  if (paymentType === "reward") return "Reward";
  if (paymentType === "minimum_payout") return "Minimum Payout";
  return paymentType.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatPaymentDate(isoDate: string, locale: string): string {
  const date = new Date(isoDate);
  const weekday = date.toLocaleDateString(locale, { weekday: "long" });
  const day = date.getDate();
  const month = date.toLocaleDateString(locale, { month: "long" });
  const year = date.getFullYear();
  return `${weekday} ${day} ${month} ${year}`;
}
